module.exports = __webpack_public_path__ + "img/voice-thumb12.49c14c7.jpg";